import { Component, OnInit } from '@angular/core';
import { WizardPageComponent } from 'src/app/core/wizard/wizard-page-component';
import { locationAccessDeniedWizard } from '../location-access-denied-wizard';

@Component({
  standalone: false,
  selector: 'mtn-location-access-denied',
  templateUrl: './location-access-denied.component.html',
  styleUrl: './location-access-denied.component.scss'
})
export class LocationAccessDeniedComponent  extends WizardPageComponent<locationAccessDeniedWizard> implements OnInit{

  key = 'location-denied'; // Unique key for this wizard page

  constructor (){
    super()
    console.log("🚀 ~ LocationAccessDeniedComponent ~ constructor ~ constructor:")
  }

  ngOnInit(): void {
    this.title ='⚠️ Access Restricted – Upgrade Required';
    this.closeButtonText = 'close';
    this.hideActionSpinner = true;
  }
}


